import { Box, BoxComponentProps } from '@dtx-company/shared-components/src'
import styled from 'styled-components'

export const DemoModalWrapper = styled(Box)<BoxComponentProps>(() => ({
  backgroundColor: 'white',
  flexDirection: 'column'
}))
